// 첫 화면 메뉴 아이콘(36×36) — 카테고리 이름으로 고른 흐름별. 흐름이 없는 카테고리는 관리자가 고른 이모지. 용지·매출·메뉴·공지는 기존 Main.js 아이콘 그대로, 프린터·결제는 같은 선 굵기로 새로.
import React from "react";

const S = { width: 36, height: 36, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" };

export const MENU_ICONS = {
    paper: (
        <svg {...S}>
            <path d="M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2H6Z" fill="#323232" fillOpacity="0.08" />
            <path d="M6 2H14L20 8V20C20 21.1 19.1 22 18 22H6C4.9 22 4 21.1 4 20V4C4 2.9 4.9 2 6 2Z" stroke="#323232" strokeWidth="1.5" fill="none" strokeLinejoin="round" />
            <path d="M14 2V8H20" stroke="#323232" strokeWidth="1.5" fill="none" strokeLinejoin="round" />
            <path d="M8 13H16M8 17H14" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    ),
    sales: (
        <svg {...S}>
            <rect x="3" y="14" width="4" height="7" rx="1" fill="#323232" fillOpacity="0.35" />
            <rect x="10" y="9" width="4" height="12" rx="1" fill="#323232" fillOpacity="0.6" />
            <rect x="17" y="4" width="4" height="17" rx="1" fill="#323232" />
        </svg>
    ),
    menu: (
        <svg {...S}>
            <path d="M3 6H15" stroke="#323232" strokeWidth="2" strokeLinecap="round" />
            <path d="M3 12H15" stroke="#323232" strokeWidth="2" strokeLinecap="round" />
            <path d="M3 18H11" stroke="#323232" strokeWidth="2" strokeLinecap="round" />
            <circle cx="19" cy="17" r="4.5" stroke="#323232" strokeWidth="1.5" fill="none" />
            <path d="M19 14.5V19.5M16.5 17H21.5" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    ),
    notice: (
        <svg {...S}>
            <path d="M11 5L6 9H3C2.45 9 2 9.45 2 10V14C2 14.55 2.45 15 3 15H6L11 19V5Z" fill="#323232" fillOpacity="0.08" stroke="#323232" strokeWidth="1.5" strokeLinejoin="round" />
            <path d="M14 8C15.66 8 17 9.79 17 12C17 14.21 15.66 16 14 16" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M17 5C19.76 5 22 8.13 22 12C22 15.87 19.76 19 17 19" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    ),
    printer: (
        <svg {...S}>
            <path d="M7 8V3h10v5" stroke="#323232" strokeWidth="1.5" strokeLinejoin="round" />
            <rect x="3" y="8" width="18" height="9" rx="2" stroke="#323232" strokeWidth="1.5" fill="#323232" fillOpacity="0.06" />
            <path d="M7 14h10v7H7z" stroke="#323232" strokeWidth="1.5" strokeLinejoin="round" fill="#fff" />
            <circle cx="17.5" cy="11" r="0.9" fill="#323232" />
        </svg>
    ),
    pay: (
        <svg {...S}>
            <rect x="2.5" y="5" width="19" height="14" rx="2.5" stroke="#323232" strokeWidth="1.5" fill="#323232" fillOpacity="0.06" />
            <path d="M2.5 9.5h19" stroke="#323232" strokeWidth="1.5" />
            <path d="M6 15h4" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    ),
};
